import React from 'react';

import {LandingPage} from './Pages/LandingPage';
import {Dashboard} from './Pages/Dashboard';
import {Payment} from './Pages/Payment';
import PaymentSuccess from "./Pages/Payment/PaymentSuccess";
import {AdminDashboard} from './Pages/Admin';
import {Page404} from "./Pages/Page404/Page404";
import {Page500} from "./Pages/Page500/Page500";
import {PrivacyPolicy} from './Pages/PrivacyPolicy'
import {roles} from "./constants";

const routes = [
    {path: '/', exact: true, auth: false, roles: [roles.ADMIN, roles.USER, roles.TRANSLATOR], name: 'Home', id: 1},
    {path: '/dashboard', auth: true, roles: [roles.USER], name: 'Dashboard', component: Dashboard, id: 2},
    {path: '/payment', auth: true, roles: [roles.USER], name: 'Payment', component: Payment, id: 3},
    {path: '/payment-success', auth: true, roles: [roles.USER], name: 'Payment Success', component: PaymentSuccess, id: 4},
    {path: '/user-requests', auth: true, roles: [roles.ADMIN, roles.TRANSLATOR], name: 'User Requests', component: AdminDashboard, id: 5},
    {path: '/service-unavailable', auth: false, roles: [roles.USER, roles.ADMIN, roles.TRANSLATOR], name: '500 error page', component: Page500, id: 6},
    {path: '/notfound', auth: false, roles: [roles.USER, roles.ADMIN, roles.TRANSLATOR], name: '400 error page', component: Page404, id: 7},
    {path: '/privacy-policy', auth: false, roles: [roles.USER, roles.ADMIN, roles.TRANSLATOR], name: 'Privacy Policy', component: PrivacyPolicy, id: 8},
];

export default routes;
